import Client from '../HttpClient';
import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const validPhase = (systemSource, merchantId, branchId) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`/api/vs/common-resource/${merchantId}/${branchId}/valid-phase`
		)
	);
};

export default {
	validPhase,
};
